package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.ui.components.loaders.CircularLoader

@Composable
internal fun BookEdgePlaceholder(
    title: String,
    bookName: String,
    align: Alignment,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .padding(horizontal = 16.dp),
    ) {
        BookEdgeHeader(
            title = title,
            bookName = bookName,
            align = align,
        )
        BookEdgeLoader(align = align)
    }
}

@Composable
private fun BoxScope.BookEdgeHeader(
    title: String,
    bookName: String,
    align: Alignment,
) {
    Column(
        modifier = Modifier.align(
            when (align) {
                Alignment.CenterStart -> Alignment.TopStart
                Alignment.CenterEnd -> Alignment.TopEnd
                else -> Alignment.TopStart
            }
        ),
        horizontalAlignment = when (align) {
            Alignment.CenterStart -> Alignment.Start
            Alignment.CenterEnd -> Alignment.End
            else -> Alignment.Start
        }
    ) {
        Text(
            text = "$title:",
            style = MaterialTheme.typography.titleMedium,
            color = Color.Black,
        )
        Text(
            text = bookName,
            style = MaterialTheme.typography.titleLarge,
            color = Color.Black,
        )
    }
}

@Composable
private fun BookEdgeLoader(align: Alignment) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = align,
    ) {
        CircularLoader(
            strokeWidth = 4.dp,
            modifier = Modifier.size(40.dp),
        )
    }
}
